var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticStyle:{"width":"100%","height":"300px","display":"block","border":"thin dashed black"},attrs:{"id":("c_" + _vm.partUUID)}})}
var staticRenderFns = []

export { render, staticRenderFns }